import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer'
import { FolderDb } from '../redux/folderDbSlice'

const useAllFoldersDb = (userId: string | undefined) : [string[], FolderDb[]] => {
  const folderDb = useSelector((state: RootState) => state.folderDb)
  const relationUserFolderDb = useSelector((state: RootState) => state.relationUserFolderDb)
  const relationIds = Object.keys(relationUserFolderDb.relationUserFolders).filter(id => relationUserFolderDb.relationUserFolders[id].userId === userId)
  const ids = relationIds.map(id => relationUserFolderDb.relationUserFolders[id].folderId)
  const folders = ids.map(id => folderDb.folders[id])

  return [ids, folders]
}

export default useAllFoldersDb
